import axios from 'axios'

const getBlogs = async () => axios.get(`${process?.env.REACT_APP_URI}/blogs`)

const getBlogDetails = async (id) =>
  axios.get(`${process?.env.REACT_APP_URI}/blogs/${id}`)

export { getBlogs, getBlogDetails }
